<template>

    <v-hover v-slot:default="{ hover }">
        <v-card
                height="80"
                :elevation="hover ? 16 : 3"
        >
            <RoommateRemove :roommate-id="roommate.id"/>

            <v-card-text class="d-flex align-center">
                <v-avatar
                        size="50"
                        class="d-flex mr-3"
                >
                    <v-img
                            :src="roommate.image_url"
                    >
                        <template v-slot:placeholder>
                            <v-avatar size="50" color="grey lighten-2">
                                <v-icon color="grey lighten-1" size="25">mdi-account-outline</v-icon>
                            </v-avatar>
                        </template>
                    </v-img>
                </v-avatar>
                <div class="d-flex flex-column">
                    <span class="roommate-name">
                        {{ roommate.name }}
                    </span>
                    <span class="roommate-info">
                        {{ roommateSubtitle }}
                    </span>
                </div>

            </v-card-text>
        </v-card>
    </v-hover>

</template>

<script>
    import moment from 'moment'
    import RoommateRemove from "./RoommateRemove";

    export default {
        name: 'RoommateCardMini',
        components: {
            RoommateRemove
        },
        props: {
            roommate: {
                type: Object,
                required: true
            }
        },
        computed: {
            school() {
                if (!this.roommate || !this.roommate.school_id) return null

                return this.$store.getters.getSchoolCampusById(this.roommate.campus_id)
            },
            roommateSubtitle() {
                if (!this.roommate || !this.roommate.id) return ''

                const subtitleArray = []
                if (this.roommate.date_of_birth) {
                    subtitleArray.push(this.dob(this.roommate.date_of_birth))
                }
                if (this.roommate.gender) {
                    subtitleArray.push(this.gender(this.roommate.gender))
                }
                if (this.school) {
                    subtitleArray.push(this.school.name);
                }
                return subtitleArray.join(' | ')
            }
        },
        data() {
            return {
                deletingRoommate: false
            }
        },
        methods: {
            dob(value) {
                if (value) {
                    return moment().diff(String(value), 'years', false)
                }
                return null
            },
            gender(value) {
                if (value && typeof value === 'string') {
                    return value.charAt(0).toUpperCase()
                }
                return null
            }
        }
    }
</script>

<style scoped>
    .head-card {
        position: relative;
    }
    .head-section {
        background-color: #F4F5F6;
    }
    .head-item-section {
        margin-left: 80px;
    }
    .head-avatar {
        position: absolute;
        margin: 0 16px 0 0;
    }
    .v-application .headline {
        font-weight: bold;
    }
    .v-application .v-btn {
        position: absolute;
        top: 5px;
        right: 5px;
    }
</style>
